import React, {useContext} from "react";
import './SideNav.css';
import {NavLink} from "react-router-dom";
import MenuIcon from '@mui/icons-material/Menu';
import BusinessIcon from '@mui/icons-material/Business';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import HomeIcon from '@mui/icons-material/Home';
import ScheduleIcon from '@mui/icons-material/Schedule';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import SettingsIcon from '@mui/icons-material/Settings';
import { CalendarMonth } from "@mui/icons-material";
import PersonPinIcon from '@mui/icons-material/PersonPin';
import useOffClick from "../../hooks/useOffClick";
import getWeekNumber from "../../helpers/utils/utils";
import { styled } from '@mui/material/styles';
import {store} from "../../store";
import {Campaign} from "../../icons/campaign";
import {hasScope} from "../../helpers/scopes";

const StyledMenuList = styled('ul')(({ theme }) => ({
  '& .active': {
    color: theme.palette.primary.main,
    borderLeft: `3px solid ${theme.palette.primary.main}`,
    backgroundColor: '#ebf1ff'
  }
}));

export default function SideNav({user, customer}) {
  const {ref, open, setOpen} = useOffClick(false);
  const [curYear, curWeek] = getWeekNumber(new Date());
  const {state} = useContext(store);

  let toggleButton = () => {
    setOpen(!open);
  };

  let close = () => {
    setOpen(false);
  };

  return (
    <div ref={ref} className={open ? 'side-nav open' : 'side-nav'}>
      <div className={'icon-container'} onClick={toggleButton}>
        <MenuIcon className="menu-icon"/>
      </div>
      <div className={'menu-container'}>

        <nav>
          {!customer &&
          <StyledMenuList>
            <li>
              <NavLink to="/sites" onClick={close}><BusinessIcon title={'Sites'}/> <span
                className={'label'}>Sites</span></NavLink>
            </li>
            {hasScope(user, 'rota:admin-read') && <li>
              <NavLink to="/performance" onClick={close}><TrendingUpIcon/> <span
                className={'label'}>Performance</span></NavLink>
            </li>}
            {user.isSiteAdmin && <li>
              <NavLink to="/users" onClick={close}> <SupervisorAccountIcon title={'Users'}/> <span
                className={'label'}>Users</span></NavLink>
            </li>}
            {user.isSiteAdmin && <li>
              <NavLink to="/questions" onClick={close}> <QuestionAnswerIcon title={'Questions'}/> <span
                className={'label'}>Questions</span></NavLink>
            </li>}
            {user.isSiteAdmin && <li>
              <NavLink to="/apikeys" onClick={close}> <VpnKeyIcon title={'API Key'}/> <span
                className={'label'}>API Key</span></NavLink>
            </li>}
          </StyledMenuList>}

          {customer && !user.onRota && <StyledMenuList>
            {customer && state.site.type !== 'hotel' && <li title={'Summary'} >
              <NavLink exact={true} to={'/' + customer} onClick={close}><DashboardIcon/> <span
                className={'label'}>Summary</span></NavLink>
            </li>}

            {customer && state.site.type === 'hotel' && customer === 'rose-castle' && <li title={'Events'}>
              <NavLink to={`/${customer}/events/list`} onClick={close}> <CalendarMonth/> <span
                className={'label'}>Events</span></NavLink>
            </li>}

            {customer === 'rose-castle' &&
              <li title={'Presence'}>
                <NavLink to={`/${customer}/presence`} onClick={close}> <PersonPinIcon title={'Presence'}/> <span
                  className={'label'}>Presence</span></NavLink>
              </li>}

            {hasScope(user, 'rota-shifts:read') ? (
              <li>
                <NavLink to={`${user.isSiteAdmin ? `/${customer}/rota/payrole`:`/${customer}/rota`}`} onClick={close}> <ScheduleIcon title={'Rota'}/> <span
                  className={'label'}>Rota</span></NavLink>
              </li>
            ) : null}

            {customer && state.site.type === 'hotel' && <li>
              <NavLink to={`/${customer}/guests`} onClick={close}> <DashboardIcon/> <span
                className={'label'}>Summary</span></NavLink>
            </li>}

            {customer && state.site.type === 'hotel' && customer !== 'rose-castle' && <li title={'Events'}>
              <NavLink to={`/${customer}/events/list`} onClick={close}> <CalendarMonth/> <span
                className={'label'}>Events</span></NavLink>
            </li>}

            {customer && state.site.type === 'hotel' && <li>
              <NavLink to={`/${customer}/campaigns`} onClick={close}> <Campaign /> <span
                className={'label'}>Campaigns</span></NavLink>
            </li>}

            {customer && state.site.type !== 'hotel' && <li title={'Forecasting'}>
              <NavLink to={`/${customer}/cast/${curWeek} ${curYear}`} onClick={close}> <TrendingUpIcon/> <span
                className={'label'}>Forecasting</span></NavLink>
            </li>}

            {customer && customer === 'lochinver-larder' && <li title={'pickup'}>
                <NavLink to={`/${customer}/pickup`} onClick={close}> <ShoppingBasketIcon/> <span
                  className={'label'}>E-Commerce</span></NavLink>
            </li>}

            {customer && customer === 'lochinver-larder' && user.isSiteAdmin && <li title={'pickup'}>
              <NavLink to={`/${customer}/events/list`} onClick={close}> <CalendarMonth/> <span
                className={'label'}>Events</span></NavLink>
            </li>}

            {user.isSiteAdmin && <li>
              <NavLink to={`/${customer}/settings`} onClick={close}> <SettingsIcon title={'Staff'}/> <span
                className={'label'}>Settings</span></NavLink>
            </li>}

            {user.isMultiSite && <li>
              <NavLink to={`/sites`} onClick={close}> <HomeIcon title={'Home'}/> <span
                className={'label'}>Home</span></NavLink>
            </li>}
          </StyledMenuList>}

          {customer && user.onRota && <StyledMenuList>

            {customer === 'rose-castle' &&
              <li title={'Presence'}>
                <NavLink to={`/${customer}/presence`} onClick={close}> <PersonPinIcon title={'Presence'}/> <span
                  className={'label'}>Presence</span></NavLink>
              </li>
            }

            {hasScope(user, 'rota-shifts:read') && (
              <li>
                <NavLink to={`/${customer}/rota/schedule`} onClick={close}> <ScheduleIcon title={'Rota'}/> <span
                  className={'label'}>Rota</span></NavLink>
              </li>
            )}
            {<li>
              <NavLink to={`/${customer}/events/list`} onClick={close}> <CalendarMonth/> <span
                className={'label'}>Events</span></NavLink>
            </li>}

            {customer && state.site.type !== 'hotel' && <li title={'Summary'}>
              <NavLink exact={true} to={'/' + customer} onClick={close}><DashboardIcon/> <span
                className={'label'}>Summary</span></NavLink>
            </li>}
            {customer && state.site.type === 'hotel' && <li>
              <NavLink to={`/${customer}/guests`} onClick={close}> <DashboardIcon/> <span
                className={'label'}>Summary</span></NavLink>
            </li>}

          </StyledMenuList>}

        </nav>
      </div>
    </div>
  );
}
